import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchClient({ updateClient=null, defaultValue=null, required=false, id="client_id", reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [q, setQ] = useState("");
    const [client, setClient] = useState(defaultValue);
    const [clients, setClients] = useState([]);

    useEffect(() => {
        if(reset)
            setIsTouched(false);
    }, [reset]);

    const searchClients = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }clients/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setClients(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchClients();
    }, [searchClients, location]);

    useEffect(() => {
        if(q.length >= 2){
            searchClients(q);
        }
    }, [searchClients, q]);
    
    useEffect(() => {
        setQ("");
        if(updateClient && client){
            updateClient(client);
        }
    }, [updateClient, client]);

    useEffect(() => {
        setClient(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ `${ id }` } className='form-control'>{ client ? (client.type === 'Company' ? client.company_name : client.last_name + " " + client.first_name) : 'Rechercher un client' }</label>
                <input type='text' id={ `${ id }` } ref={ autocompleteInputRef } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ client ? (client.type === 'Company' ? client.company_name : client.last_name + " " + client.first_name) : 'Rechercher un client' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { clients.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setClient(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> { item.type === 'Company' ? item.company_name : item.last_name + " " + item.first_name }</li>
                        )
                    }) }
                    { clients.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { isTouched && required && client === null && <div className='form-error'>Veuillez sélectionner le client.</div> }
        </>
    )
}
